import type { ReactNode } from "react"
import BigHeading from "../../BigHeading"
export function WorkSection({
  children,
  className = "",
  sectionId,
  title,
}: {
  children: ReactNode
  className?: string
  sectionId?: string
  title: string
}) {
  return (
    <section
      className={className}
      data-section={sectionId}
    >
      <BigHeading variant="h3">{title}</BigHeading>
      <div className="block w-full p-[1rem] max-sm:p-[8px]">{children}</div>
    </section>
  )
}

export default WorkSection
